'use strict'

export default class ProcedureStatusService {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  setTheStates() {
    return this.$http.get('/api/schedules/patientPortal/')
  }

}

ProcedureStatusService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./client/app/account/procedureStatus/procedureStatus.service.js